// extracted by mini-css-extract-plugin
module.exports = {"link":"_8TWqu","root":"_1y-_d","label":"jVqNk"};